export const WEBFRAME_MODULE_NAME = 'Webframe';
export const CONFIG_MODULE_NAME = 'Config';
export const COCKPIT_MODULE_NAME = 'Cockpit';
